export const SubAbasContratos = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/fornecedor/contratos/contratos/ficha/${id}/dadosgerais`,
  },
  // {
  //   label: 'Destaques',
  //   rota: `/fornecedor/contratos/contratos/ficha/${id}/dadosgerais`,
  // },
];

export const SubAbasContratosNovo = [
  {
    label: 'Dados Gerais',
    rota: `/fornecedor/contratos/contratos/ficha/dadosgerais`,
  },
  // {
  //   label: 'Destaques',
  //   rota: `/fornecedor/contratos/contratos/ficha/destaques`,
  // },
];
